import actionTypes from "../actionTypes";
import IAction from "../../types/IAction";
import ICharity from "../../types/services/ICharity";

interface State {
  isLoggedIn: boolean;
  remember: boolean;

  id: string;
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  photoUrl: string;

  currentCharity: ICharity;
  charities: Array<ICharity>;
  isSuperadmin: boolean;
  isDonationReader: boolean;
  isOnboardingOperator: boolean;
}

const initialState: State = {
  isLoggedIn: false,
  remember: false,

  id: "",
  name: "",
  email: "",
  firstName: undefined,
  lastName: undefined,
  photoUrl: undefined,
  isSuperadmin: false,
  isDonationReader: false,
  isOnboardingOperator: false,
  currentCharity: { id: "", name: "", role: "" },
  charities: [],
};

export default function loginReducer(
  state: State = initialState,
  action: IAction
): State {
  switch (action.type) {
    case actionTypes.LOGIN_USER: {
      return {
        ...state,
        id: action.meta.user.id,
        name: action.meta.user.name,
        firstName: action.meta.user.firstName,
        lastName: action.meta.user.lastName,
        email: action.meta.user.email,
        photoUrl: action.meta.user.photoUrl,
        currentCharity: action.meta.currentCharity,
        charities: action.meta.charities,
        isSuperadmin: action.meta.user.isSuperadmin,
        isDonationReader: action.meta.user.isDonationReader,
        isOnboardingOperator: Boolean(action.meta.user.isOnboardingOperator),
        isLoggedIn: true,
      };
    }

    case actionTypes.LOGOUT_USER: {
      return {
        ...state,
        isLoggedIn: false,
        id: "",
        name: "",
        email: action.meta.remember ? state.email : "",
        firstName: undefined,
        lastName: undefined,
        photoUrl: undefined,
        currentCharity: { id: "", name: "", role: "" },
        isSuperadmin: false,
        isDonationReader: false,
        isOnboardingOperator: false,
        charities: [],
      };
    }

    case actionTypes.CHANGE_CURRENT_CHARITY: {
      return {
        ...state,
        currentCharity: action.meta.currentCharity,
      };
    }

    case actionTypes.UPDATE_PHOTO_URL: {
      return {
        ...state,
        photoUrl: action.meta.photoUrl,
      };
    }

    case actionTypes.UPDATE_PROFILE: {
      return {
        ...state,
        name: action.meta.name,
        firstName: action.meta.firstName,
        lastName: action.meta.lastName,
      };
    }

    case actionTypes.REMEMBER_USER: {
      return {
        ...state,
        email: "",
        remember: !state.remember,
      };
    }

    case actionTypes.UPDATE_CHARITIES: {
      return {
        ...state,
        charities: action.meta.charities,
      };
    }

    default: {
      return state;
    }
  }
}

export { initialState };
